export default "__VITE_ASSET__CkrmoDen__"